import { makeStyles } from "@material-ui/core/styles";

const styles = makeStyles(({ spacing, palette }) => ({
  root: {
    position: "relative",
    minHeight: "min-content",
    display: "flex",
    flexDirection: "column",
    width: "100%",
    gap: spacing(2),
  },
  footer: {
    position: "absolute",
    left: 0,
    bottom: 0,
    width: "100%",
    zIndex: 11,
    borderTop: `1px solid ${palette.separator.main}`,
    paddingTop: spacing(2),
    backgroundColor: palette.otherElementsBackground.main,
    display: "flex",
    flexDirection: "column",
    gap: spacing(2),
  },
}));
export default styles;
